export default {
	project_name: 'Escola do Varejo',
	login_azure: 'Acesso Direto GB',
}
